export default {
  pom: {
    title: {
      en: 'Perfume of the month',
    },
    subTitle: {
      en: 'You can change it after subscription',
    },
  },
  firstMonth: {
    en: '{priceWithDiscount}/First month',
  },
  saved: {
    en: 'Saved: {discount}',
  },
}
